import { useNavigate, useLocation } from 'react-router-dom';

const useRemoveParams = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const removeUrlParams = () => {
        const pn = location.pathname.split("/")[1];
        
         navigate("../" + pn, { replace: true }); // Get the current path without query params // Update URL without causing a reload
        
    };

    return removeUrlParams;
};

export default useRemoveParams;